import React, { useEffect, useRef, useState, useContext } from "react";

import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { confirmDialog } from "primereact/confirmdialog";

import Card from "../../../../Base/Components/Card/Card";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import { toastShow } from "../../../../Base/Services/ToastService";

import { getPosiciones, postChangeEstado } from "../../../../API/RRHH/Posiciones/PosicionesRequest";
import { getEstadosCategory } from "../../../../API/Global/Status/StatusRequests";

import PosicionesCRUD from "./PosicionesCRUD";
import FormatoPosicion from "./FormatoPosicion";



const PosicionesScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [posiciones, setPosiciones] = useState([]);
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [dialogFormato, setDialogFormato] = useState(false);
  const [estados, setEstados] = useState([]);


  const getInfo = async () => {
    setLoading(true);
    const pos = await getPosiciones();
    const estadosTempo = await getEstadosCategory('General')
    setEstados(estadosTempo?.filter(i => i?.IdStatus !== 7))
    setPosiciones(pos);
    setLoading(false);
  };

  const changeEstado = ({ data, api }) => {
    return <div>
          <Dropdown
            value={estados.filter(e => e.IdStatus === data.IdStatus)[0]}
            options={estados}
            optionLabel="StatusName"
            filter
            filterBy="StatusName"
            style={{ width: '100%' }}
            onChange={(e) => {
              let changes = []
              if(selected.length > 0 ){
                changes = selected.map(item => {
                  return {
                    IdPosicion: item.IdPosicion,
                    IdStatus: e.value.IdStatus,
                    StatusName: e.value.StatusName
                  }
                })
              } else{
                changes.push({
                  IdPosicion: data.IdPosicion,
                  IdStatus: e.value.IdStatus,
                  StatusName: e.value.StatusName
                })
              }
              confirmDialog({
                message: `¿Cambiar a estado ${e.value.StatusName} a ${changes.length} Posiciones ?`,
                header: 'Confirmación',
                icon: 'pi pi-exclamation-triangle',
                accept: async () => {
                  let IdPosiciones = changes.map(item => item.IdPosicion);
                  cambiarEstadoCliente(e.value.IdStatus, IdPosiciones.toString());
                  getInfo();
                  api.stopEditing();
                },
                reject: () => {
                  getInfo();
                }
              })
            }}
          />
      </div>
  }
 
  const cambiarEstadoCliente = async (IdStatus, IdPosiciones) => {
    const result = await postChangeEstado({ IdStatus, IdPosiciones });
    toastShow(toast, "success", "Actualizado", "Estado cambiado exitosamente");
  };


  const columns = [
    {
      field: "IdPosicion",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: 1,
      onCellDoubleClicked: ({ data }) => {
        if(data?.IdPosicion > 0){
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "CodigoPosicion",
      header: "Código",
      headerEn: "Code",
      frozen: 1,
      className: "Xsmall",
      Format: 'Modal',
      onCellDoubleClicked: ({ data }) => {
        if(data?.IdPosicion > 0){
          setShowDialog(true);
          setSelected([data]);
        }
      },
      Sumary: 'count',
    },
    {
      field: "Posicion",
      header: "Posición",
      frozen: 1,
      headerEn: "Position",
      className: "XXlarge",
      onCellDoubleClicked: ({ data }) => {
        if(data?.IdPosicion > 0){
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "small",
      Format: "Estado",
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
      cellEditor: changeEstado,
      editable: (rowData) => {
        if(rowData.data?.IdPosicion){
          return true
        }else{
          return false
        }
      } 
    },
    {
      field: "Area",
      header: "Area",
      headerEn: "Area",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        if(data?.IdPosicion > 0){
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Dependencia",
      header: "Dependencia",
      headerEn: "Dependency",
      className: "Xlarge",
      onCellDoubleClicked: ({ data }) => {
        if(data?.IdPosicion > 0){
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "PerfilOcupacional",
      header: "Perfil",
      headerEn: "Profile",
      className: "XXXlarge",
      onCellDoubleClicked: ({ data }) => {
        if(data?.IdPosicion > 0){
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Objetivo",
      header: "Objetivo",
      headerEn: "Objectives",
      className: "XXXlarge",
      onCellDoubleClicked: ({ data }) => {
        if(data?.IdPosicion > 0){
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Educacion",
      header: "Educación",
      headerEn: "Education",
      className: "XXXlarge",
      onCellDoubleClicked: ({ data }) => {
        if(data?.IdPosicion > 0){
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "TipoTrabajo",
      header: "Tipo Trabajo",
      headerEn: "Job Type",
      className: "small",
      onCellDoubleClicked: ({ data }) => {
        if(data?.IdPosicion > 0){
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Conocimiento",
      header: "Conocimiento",
      headerEn: "Knowledge",
      className: "XXlarge",
      onCellDoubleClicked: ({ data }) => {
        if(data?.IdPosicion > 0){
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Nomina",
      header: "Nómina",
      headerEn: "Payroll",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        if(data?.IdPosicion > 0){
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "RangoSalario",
      header: "Rango Salarial",
      headerEn: "Salary Range",
      className: "medium",
      Format: 'Currency',
      onCellDoubleClicked: ({ data }) => {
        if(data?.IdPosicion > 0){
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Description",
      header: "Descripción",
      headerEn: "Description",
      className: "Xlarge",
      onCellDoubleClicked: ({ data }) => {
        if(data?.IdPosicion > 0){
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "FechaRevisionStr",
      header: "Fecha Revisión",
      headerEn: "Review Date",
      Format: 'DateTime',
      className: "medium",
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creado",
      headerEn: "Date Create",
      Format: 'DateTime',
      className: "medium",
    },
    {
      field: "UserNameCreate",
      header: "User Create",
      headerEn: "User Create",
      className: "medium",
    },
    {
      field: "IdPosicion",
      header: "",
      Format: "Botones",
      filter: false,
      frozen: 1,
      alignFrozen: "right",
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          tooltipOptions: { position: "left", },
          onClick: (rowData) => {
            if(rowData?.IdPosicion > 0){
              setShowDialog(true);
              setSelected([rowData]);
            }
          },
        },
        {
          icon: "pi pi-print",
          tooltip: "Formato",
          tooltipOptions: { position: "left", },
          onClick: (rowData) => {
            if(selected?.length > 1){
              toastShow(toast, 'warn', 'Advertencia', 'Solo se muestra el formato de una Posición.')
            }
            setTimeout(() => {              
              if(rowData?.IdPosicion > 0){
                setDialogFormato(true);
                setSelected([rowData]);
              }
            }, 500);
          },
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: posiciones,
    loading: loading,
    selected: selected,
    setSelected: setSelected,
    showModal : () => {}
  };


  useEffect(() => {
    setTitlePage(getLabel(baseLang, "posicionRHH", config.language));
    getInfo();
  }, []);

  return (
    <div
    className=" p-fluid px-4"
    style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "posicionRHH", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              severity="success"
              onClick={() => {
                setShowDialog(true);
                setSelected([]);
              }}
            />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />

      {showDialog && (
        <PosicionesCRUD
          showDialog={showDialog}
          setShowDialog={setShowDialog}
          getInfo={getInfo}
          selected={selected}
          setSelected={setSelected}
          modo={selected?.length > 0  ? "Editar" : "Crear"}
        />
      )}

      {dialogFormato && (
        <FormatoPosicion
          dialogFormato={dialogFormato}
          setDialogFormato={setDialogFormato}
          selected={selected}
          setSelected={setSelected}
        />
      )}
    </div>
  );
};

export default PosicionesScreen;
